/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsLocationDot: {
  name: 'location-dot';
  data: string;
} = {
  name: 'location-dot',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 10a6 6 0 1 1 12 0c0 1.703-.995 3.685-2.346 5.545-1.297 1.787-2.804 3.301-3.654 4.103-.85-.802-2.356-2.316-3.654-4.103C6.996 13.685 6 11.703 6 10Zm6-8a8 8 0 0 0-8 8c0 2.369 1.326 4.79 2.728 6.72 1.428 1.968 3.07 3.605 3.954 4.434a1.92 1.92 0 0 0 2.636 0c.884-.83 2.526-2.466 3.954-4.434C18.674 14.79 20 12.37 20 10a8 8 0 0 0-8-8Zm-1 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0Zm1-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z" fill="currentColor"/></svg>`,
};
